import { Controller } from '@hotwired/stimulus'

export default class PasswordVisibilityController extends Controller {
  static targets = ['passwordInput', 'showIcon', 'hideIcon'];

  toggle() {
    if (this.passwordInputTarget.type === 'password') {
      this.passwordInputTarget.type = 'text';
      this._toggleClass();
      this.hideIconTarget.focus();
    } else {
      this.passwordInputTarget.type = 'password';
      this._toggleClass();
      this.showIconTarget.focus();
    }
  }

  _toggleClass() { // needs to be done before moving the focus
    this.showIconTarget.classList.toggle('d-none');
    this.hideIconTarget.classList.toggle('d-none');
  }
}
